import { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Row, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NEWS_TITLE_MAP = {
  "recentInsiderBuy": "최근 내부자 거래 매수 소식이 떴어요!",
  "recentInsiderFrequentBuy": "가장 많은 내부자가 샀어요!",
  "recentInsiderAmountHighBuy": "거래금액이 가장 높아요!"
};
const INSIDER_NEWS_TYPES = ["recentInsiderBuy", "recentInsiderFrequentBuy", "recentInsiderAmountHighBuy"];

export default function HomeInsiderNewsSection({ data }) {
  const navigate = useNavigate();
  const insiderNews = useMemo(() => (Array.isArray(data) ? data : []), [data]);
  const filteredInsiderNews = useMemo(() => Object.fromEntries(
    INSIDER_NEWS_TYPES.map((seltype) => [
      seltype,
      insiderNews
        .filter((item) => item?.seltype === seltype)
        .sort((a, b) => a.rank - b.rank)
        .slice(0, 6)
    ])
  ), [insiderNews]);

  const randomSeltype = useMemo(
    () => INSIDER_NEWS_TYPES[Math.floor(Math.random() * INSIDER_NEWS_TYPES.length)],
    []
  );

  const newsTitle = NEWS_TITLE_MAP[randomSeltype] || "인사이더 뉴스";
  const newsItems = useMemo(() => filteredInsiderNews[randomSeltype] || [], [filteredInsiderNews, randomSeltype]);
  const [selectedNewsItem, setSelectedNewsItem] = useState(newsItems[0] || null);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setSelectedNewsItem(newsItems[0] || null);
  }, [newsItems]);

  useEffect(() => {
    setImageError(false);
  }, [selectedNewsItem]);

  const handleTickerMove = useCallback((event, ticker) => {
    event.stopPropagation();
    navigate(`/stock/${ticker}`);
  }, [navigate]);

  // Extract documentId from selectedNewsItem.info
  const parsedInfo = useMemo(() => {
    if (!selectedNewsItem?.info) {
      return null;
    }
    
    try {
      return JSON.parse(selectedNewsItem.info.split("'").join('"'));
    } catch (error) {
      return null;
    }
  }, [selectedNewsItem]);
  
  const selectedDocumentId = parsedInfo ? (parsedInfo.documentId === undefined ? parsedInfo.lastDocumentId : parsedInfo.documentId) : "";
  const { year, month } = useMemo(() => {
    const baseDate = parsedInfo?.reportDate || parsedInfo?.lastReportDate;
    const dateText = String(baseDate);
    const extractedYear = dateText.slice(0, 4);
    const extractedMonth = dateText.slice(5, 7);

    return {
      year: extractedYear,
      month: extractedMonth,
    };
  }, [parsedInfo]);
  
  const imgSrc = selectedNewsItem ? `https://whisperj.s3.ap-northeast-2.amazonaws.com/image/${year}/${month}/${selectedDocumentId}_${selectedNewsItem.ticker}_P.png` : "";

  return (
    <Row>
      <Col>
        <Card>
          <Card.Body>
            <div className="home-section-header">
              <div>
                <div className="home-section-title">{newsTitle}</div>
                <div className="home-section-subtitle mb-3">내부자 거래 소식으로 시장의 흐름을 읽어보세요.</div>
              </div>
              <button type="button" className="home-section-link" onClick={() => { navigate("/insider") }}>
                더보기
              </button>
            </div>
            <Row>
              <Col sm="12" md="6" lg="6" className="order-2 order-md-1">
                {newsItems.map((item, index) => {
                  const titleText = `${item.companyKor} (${item.ticker})`;
                  const dateText = item.pubdate;
                  const cardKey = `${item.ticker}-${item.pubdate}-${index}`;

                  return (
                    <Card
                      key={cardKey}
                      className="mb-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => setSelectedNewsItem(item)}
                    >
                      <Card.Header className="home-insider-item-header d-flex justify-content-between align-items-center">
                        <div
                          type="button"
                          className="home-insider-item-title text-primary"
                          onClick={(event) => handleTickerMove(event, item.ticker)}
                        >
                          {titleText}
                        </div>
                        <div className="text-muted home-insider-item-date">{dateText}</div>
                      </Card.Header>
                      <Card.Body className="text-secondary">
                        <div className="home-insider-item-intro">
                          {item.intro}
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </Col>
              <Col sm="12" md="6" lg="6" className="order-1 order-md-2 mb-3 mb-md-0">
                {selectedNewsItem ? (
                  imageError ? (
                    <div
                      className="d-flex align-items-center justify-content-center text-center w-100  h-100 "
                      style={{
                        padding: "24px",
                        backgroundColor: "#f8f9fa",
                        color: "#6c757d",
                        borderRadius: "0.5rem"
                      }}
                    >
                      이미지 생성을 위한 데이터가 충분치 않습니다.
                    </div>
                  ) : (
                    <img
                      src={imgSrc}
                      alt="Insider News"
                      className="img-fluid w-100vertical-middle"
                      style={{ objectFit: "cover", backgroundColor: "#f8f9fa", borderRadius: "0.5rem" }}
                      onError={() => setImageError(true)}
                    />
                  )
                ) : null}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
